/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedNationalityDropdown200,
  GetApiV1PersonSharedNationalityDropdown401,
  GetApiV1PersonSharedNationalityDropdown500,
  GetApiV1PersonSharedNationalityDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedNationalityDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedNationalityDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1PersonSharedNationalityDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedNationalityDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedNationalityDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedNationalityDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedNationalityDropdown500>;

export const getApiV1PersonSharedNationalityDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedNationalityDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedNationalityDropdownQueryResponse>;
